import {
  Card,
  CardContent,
  FormControl,
  FormHelperText,
  Grid,
  Input,
  InputLabel,
  TextField,
} from "@mui/material";
import { useFormContext } from "react-hook-form";
import { VRSTA_OPERATERA } from "../../../../enums";
import {
  OstaliIdentifikatori,
  PorukaGreskePolja,
  PrimarniIdentifikatorDrzavaIzdavaljetelj,
  PrimarniIdentifikatorDrzavaNaziv,
  PrimarniIdentifikatorDrzavaRezidentnosti,
  PrimarniIdentifikatorVrijednost,
} from "../../../index";
import PrimarniIdentifikatorNaziv from "../PrimarniIdentifikatorNaziv";

const Index = () => {
  const {
    register,
    getValues,
    formState: { errors },
    watch,
  } = useFormContext();
  const vrstaOperatera = parseInt(
    getValues("operaterPlatforme.vrstaOperatera.id")
  );

  return (
    <Card variant={"outlined"} sx={{ mt: 3 }}>
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={vrstaOperatera === VRSTA_OPERATERA.IZ_RH ? 12 : 6}>
            <PrimarniIdentifikatorVrijednost />
          </Grid>
          {vrstaOperatera !== VRSTA_OPERATERA.IZ_RH && (
            <Grid item xs={6}>
              <PrimarniIdentifikatorDrzavaIzdavaljetelj
                nazivPolja={
                  "operaterPlatforme.primarniIdentifikator.drzavaIzdavatelj.oznaka"
                }
                nazivPoljaEu={
                  "operaterPlatforme.primarniIdentifikator.drzavaIzdavatelj.euSifra"
                }
                registracija={true}
              />
            </Grid>
          )}
          {vrstaOperatera === VRSTA_OPERATERA.IZ_RH && (
            <>
              <Input
                type={"hidden"}
                defaultValue={"HRV"}
                value={"HRV"}
                {...register(
                  "operaterPlatforme.primarniIdentifikator.drzavaIzdavatelj.oznaka"
                )}
              />
              <Input
                type={"hidden"}
                defaultValue={"HR"}
                value={"HR"}
                {...register(
                  "operaterPlatforme.primarniIdentifikator.drzavaIzdavatelj.euSifra"
                )}
              />
            </>
          )}
          <Grid item xs={12}>
            <PrimarniIdentifikatorDrzavaRezidentnosti />
          </Grid>
          <Grid item xs={12}>
            <PrimarniIdentifikatorDrzavaNaziv />
          </Grid>
          <Grid item xs={12}>
            <OstaliIdentifikatori
              nazivPolja={"operaterPlatforme.ostaliIdentifikatori"}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default Index;
